import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-orrecord-volume',
  templateUrl: './orrecord-volume.component.html',
  styleUrls: ['./orrecord-volume.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class OrrecordVolumeComponent implements OnInit {

  columnsToDisplay = ['Name', 'Description', 'IsActive'];
  headercolumnsToDisplay = ['Volume', 'Description', 'Is Active'];
  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  orrecordvolumeform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.orrecordvolumeform = this.formBuilder.group({

      name: ['',],
      isactive: ['',],
      description: ['',],
      names: ['',],
      isactivee: ['',],
      descriptionn: ['',]

    });
  }

  get f() { return this.orrecordvolumeform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.orrecordvolumeform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.orrecordvolumeform.value))
  }
}
